module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nextLabel":"Next","moreLabel":"more"},"es":{"nextLabel":"Siguiente","moreLabel":"más"}}')
  delete Component.options._Ctor
}
